import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tenant-list-modal',
  templateUrl: './tenant-list-modal.component.html',
  styleUrls: ['./tenant-list-modal.component.css']
})
export class TenantListModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
